/**
 * --------------------------------------------------
 * Accordion Module
 *
 * @module Accordion
 * --------------------------------------------------
 */

export default {
    $accordionElem: null,
    $accordionItemElem: null,
    _accordionBody: null,
    _activeClass: 'active',

    setup: function() {
        this.$accordionElem = $( '.rt-js-accordion' );
        this.$accordionItemElem = this.$accordionElem.find( '.rt-js-accordion-item' );
        this._accordionBody = ( '.rt-js-accordion-body' );

        // Add event listeners
        this.addListeners();
    },

    // Add event listeners
    addListeners: function() {
        const _self = this;

        // attach click to each item
        this.$accordionItemElem.on('click', function(e) {
            
            // find the parent accordion container for this clicked item
            const $parentAccordion = $(this).closest(_self.$accordionElem);
            
            // query items only within that accordion
            const $itemsInThisAccordion = $parentAccordion.find(_self.$accordionItemElem);
            
            _self._openClose(this, $itemsInThisAccordion);
        });
    },

    // Open close function
    _openClose($el, $bodies) {
        const $elem = $($el);
        const $body = $elem;

        // Close other bodies
        $bodies.not($body).removeClass(this._activeClass);

         // Toggle clicked body
        $body.toggleClass(this._activeClass);
    }
}